import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const AlignCenterIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 19, height: 19, viewBox: "0 0 19 19", version: "1.1" }, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M15.7454545,15 C15.8860361,15 16,15.0895431 16,15.2 L16,15.8 C16,15.9104569 15.8860361,16 15.7454545,16 L2.25454545,16 C2.11396388,16 2,15.9104569 2,15.8 L2,15.2 C2,15.0895431 2.11396388,15 2.25454545,15 L15.7454545,15 Z M12.8,6 C12.9104569,6 13,6.08954305 13,6.2 L13,12.8 C13,12.9104569 12.9104569,13 12.8,13 L5.2,13 C5.08954305,13 5,12.9104569 5,12.8 L5,6.2 C5,6.08954305 5.08954305,6 5.2,6 L12.8,6 Z M12,7 L6,7 L6,12 L12,12 L12,7 Z M15.7454545,3 C15.8860361,3 16,3.08954305 16,3.2 L16,3.8 C16,3.91045695 15.8860361,4 15.7454545,4 L2.25454545,4 C2.11396388,4 2,3.91045695 2,3.8 L2,3.2 C2,3.08954305 2.11396388,3 2.25454545,3 L15.7454545,3 Z",
    id: "alignCenterPath"
  }
)), /* @__PURE__ */ React.createElement("g", { id: "Image_Center", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("mask", { fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#alignCenterPath" })), /* @__PURE__ */ React.createElement("use", { fill: "currentColor", fillRule: "nonzero", xlinkHref: "#alignCenterPath" })));

export { AlignCenterIcon as default };
//# sourceMappingURL=AlignCenterIcon.js.map
